define('views/components/reseller_manager/reseller_manager_list',['require','views/base/list_view','views/components/reseller_manager/reseller_manager','text!templates/components/reseller_manager/reseller_manager_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/reseller_manager/reseller_manager');

    var temp = require("text!templates/components/reseller_manager/reseller_manager_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

